import { Alert, Stack, Typography, useMediaQuery } from '@mui/material'
import { CommonStepContent } from './CommonStepContent'
import { theme } from '~/lib/theme'

export const IntroductionStep = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const messages = [
    'これまでのキャンペーンでは、インフルエンサーの方に商品を無償で提供する「無償提供型」のみをご利用いただいておりましたが、今回、新たに商品代金を一時的に立て替える「立替型」が加わりました。',
    'それぞれの方式には特徴や進め方に違いがございますので、内容をご確認のうえ、適切な方式をお選びください。',
  ]

  return (
    <CommonStepContent>
      <Alert severity="info" icon={isMobile ? false : undefined}>
        <Stack gap={0.5}>
          <Stack gap={0.5}>
            {messages.map((line, index) => (
              <Typography key={index} variant="body2">
                {line}
                <br />
              </Typography>
            ))}
          </Stack>
        </Stack>
      </Alert>
    </CommonStepContent>
  )
}
